import React from 'react';
import './StyledByTaakagirls.css';

const taakaGirlsData = [
  {
    id: 1,
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Taakagirls%2Fimg1.webp?alt=media&token=d71b0c1f-7f46-4ac9-acfd-12523dc452ca',
    productLink: '/product/midnight-polka-skirt'
  },
  {
    id: 2,
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Taakagirls%2FIMG_5472.webp?alt=media&token=6d930ce9-5705-4da8-ac80-5a241b93ee60',
    productLink: '/product/gingham-midi-dress'
  },


   {
    id: 3,
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Taakagirls%2FIMG_5494.webp?alt=media&token=5f6d3e2f-292e-4454-87b3-2a04e01bc226',
    productLink: '/product/ivory-flora-top'
  },

 

  {
    id: 4,
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Taakagirls%2FIMG_4758.webp?alt=media&token=fa1fc584-bc32-49ad-833d-451f7bb0f7e6',
    productLink: '/product/capri-blue-dress'
  },

  {
    id: 5,
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Taakagirls%2FIMG_5482.webp?alt=media&token=2248e4de-b673-4917-a0ef-e32cf4f148df',
    productLink: '/product/lemon-midi-skirt'
  },
  
 {
    id: 6,
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Taakagirls%2Fimg12.webp?alt=media&token=c88eba7b-ece2-49d0-b58a-218291c1af97',
    productLink: '/product/midnight-polka-skirt'
  },

   {
    id: 7,
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Taakagirls%2Fimg_5444.webp?alt=media&token=d32ce337-1226-41a4-8c58-abaa0f6277ab',
    productLink: '/product/bubblegum-skirt'
  },

  {
    id: 8,
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Taakagirls%2Fimg13.webp?alt=media&token=ba79d4ad-0e3e-4936-ab2d-bf0f0e3584ed',
    productLink: '/product/amber-wrap-top'
  }
];

const StyledByTaakagirls = () => {
  return (
    <section className="taakagirls-section">
      <div className="taakagirls-heading">Styled by our Taakagirls</div>

      <div className="taakagirls-grid">
        {taakaGirlsData.map((post) => (
          <div key={post.id} className="taakagirl-card">
            <img
              src={post.imageUrl}
              alt="Taakagirl styled look"
              className="taakagirl-img"
              loading="lazy"
            />

            <div className="taakagirl-overlay">
              <a href={post.productLink} className="taakagirl-shop-btn">
                Shop the Look
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StyledByTaakagirls;